import { Component, OnInit } from '@angular/core';
import {RealmService} from '../Services/Realm/realm.service';
import {ApiService} from '../Services/Api/api.service';
import {SessionService} from '../Services/Session/session-service.service';
import {FirebaseService} from '../Services/Firebase/firebase.service';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MessageService, SelectItem} from 'primeng/api';
import {Router} from '@angular/router';
import {AuthService} from '../auth.service';
import {environment} from "../../environments/environment.prod";


@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css', '../../assets/layout/style/layout.css'],
  providers: [MessageService]
})
export class RegisterComponent implements OnInit {
  userform: FormGroup;
  submitted: boolean;
  items: any[];
  countryTitle: string;
  selectedCity: string;
  phoneTitle: string;
  emailTitle: string;
  dpiTitle: string;
  loginBtnTitle: string;
  fcmToken: string;
  masks = 'dd/MM/yyyy';
  env = environment;
  constructor(private realm: RealmService, private api: ApiService, private st: SessionService,
              private Rc: FirebaseService, private fb: FormBuilder, private auth: AuthService,
              private router: Router, private messageService: MessageService) {
  }

  ngOnInit() {
    this.realm.loginAsync().then(data=>{
      console.log(data);
    });
    //this.getFcm();
    this.api.responseApiRegister$
      .subscribe((data:any) => {
        console.log('data ws register: ', data);
        const dat = JSON.parse(JSON.stringify(data));
        // @ts-ignore
        if (data.code === 701) {
          // @ts-ignore
          this.env.sendOtpNewDevice = false;
          this.auth.setRegisterIn(true);
          this.st.saveParam('register', 'true');
          this.router.navigate(['/otp']);
          /*
          const s: object = dat.result;
          if (s.hasOwnProperty('success')) {
            this.auth.setRegisterIn(true);
            // @ts-ignore
            const a = s.success;
            this.st.saveParam('register', 'true');
            this.router.navigate(['/otp']);
          }*/
        } else {
          console.log("entra al else 701 register ")
          //console.log(this.Rc.getStringRC('global_message_'+"610"));
          // tslint:disable-next-line:max-line-length
          this.messageService.add({severity: 'error', summary: 'error', detail: this.Rc.getStringRC('global_message_'+data.code), sticky: false});
        }
      });
      /*
    this.realm.countriesArea$.subscribe(data => {
      // @ts-ignore
      this.items = data.data.countryCodeAppSettingsOrms;
    });*/
    this.Rc.fetchActivate().then(() => {
      console.log('pais:::::: ', this.Rc.getStringRC('global_select_country_title'));
      this.phoneTitle = this.Rc.getStringRC('global_phone_number');
      this.dpiTitle = this.Rc.getStringRC('global_number_id');
      this.emailTitle = this.Rc.getStringRC('global_email_address');
      this.loginBtnTitle = this.Rc.getStringRC('global_accept');
      this.countryTitle = this.Rc.getStringRC('global_select_country_title');
    });
    this.realm.loginAsync().then(() => {
    });
    this.realm.getCountriesArea().then((data:any) => {
      this.items = data.data.countryCodeAppSettingsOrms;
    })
    this.userform = this.fb.group({
      phoneNumber: new FormControl('', [Validators.required, Validators.minLength(4)]),
      dpi: new FormControl('', Validators.required),
      email: new FormControl('', Validators.required),
      country: new FormControl('', Validators.required)
    });
    //this.selectedCity = this.userform.get('country').value;
  }
  setvalues() {
    const t =  this.items[0];
    this.userform.patchValue({
      country: t,
      phoneNumber: '31505513',
      email: 'sergios@mediprocesos.com',
      dpi: '2631941240101',
    });
  }
  onSubmit(value: string) {
    this.submitted = true;
    //this.messageService.add({severity: 'info', summary: 'Success', detail: 'Form Submitted', sticky: false});
    const q = JSON.parse(JSON.stringify(value));
    console.log("onsubmitted");
    console.log(q);
    this.realm.getRegisterSettings(q.country.idCode, q.phoneNumber, q.email, q.dpi, 'POST');
  }
  getFcm() {
    /*this.st.getvvalueSession('data', 'fcmToken').then( r => {
      this.fcmToken = r;
    });*/
    this.fcmToken = 'prueba';
  }

  showViaService() {
    this.messageService.add({severity:'success', summary:'Service Message', detail:'Via MessageService'});
}
}
